import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Apiservice } from './api.service';
@Injectable({
  providedIn: 'root'
})
export class VivifirService {

  constructor(private Apiservice: Apiservice, private httpClient:HttpClient) { }

  /*
  loginViviFirSoggetto(id){

    //LoginRentriBySoggetto?IdSoggetto=1

    const EndPoint=environment.BASE_API_URL+"ViviFir/LoginVivifirBySoggetto?IdSoggetto="+id;
    const headers = this.Apiservice.httpOptionCall();

    const response =  this.httpClient.post(EndPoint,'',headers).toPromise();
  
    return response;
  }
  */

  getDettaglioFir(idSoggetto:number,blocco,progressivo,pdfShow){
    
    const EndPoint=environment.BASE_API_URL+`ViviFir/getFIR?IdSoggetto=${idSoggetto}&blocco=${blocco}&progressivo=${progressivo}&pdf=${pdfShow}`

    const headers = this.Apiservice.httpOptionCall();

    const response =  this.httpClient.get(EndPoint,headers).toPromise();

    return response;
  }
  
  generaFir(idSoggetto:any,blocco,numeroFir){
    const EndPoint=environment.BASE_API_URL+`ViviFir/generaFir?IdSoggetto=${idSoggetto}&blocco=${blocco}&numfir=${numeroFir}`;
    // const EndPoint=environment.BASE_API_URL+`RentriOld/GeneraViviFir?IdSoggetto=${idSoggetto}&codice_blocco=${blocco}&numfir=${numeroFir}`;
    const headers = this.Apiservice.httpOptionCall();

    const response:any =  this.httpClient.post(EndPoint,'',headers).toPromise();

    return response;

  }

  async syncBlocchi(IdSoggetto : number){

    const EndPoint=environment.BASE_API_URL+`ViviFir/SincronizzaBlocchi?IdSoggetto=${IdSoggetto}`;
    const headers = this.Apiservice.httpOptionCall();

    const response = await this.httpClient.put<any[]>(EndPoint,undefined,headers).toPromise();

    return response;

  }
 
  async annullaFir(blocco,IdSoggetto,progressivo){
    
    const EndPoint=environment.BASE_API_URL+`ViviFir/annullaFir?IdSoggetto=${IdSoggetto}&blocco=${blocco}&progressivo=${progressivo}`;
    const headers = this.Apiservice.httpOptionCall();

    const response = await this.httpClient.put<any[]>(EndPoint,undefined,headers).toPromise();

    return response;
  }
}
